import React from "react";
import { FlexibleLoadingSpinner } from "clutch/src/LoadingSpinner/LoadingSpinner.jsx";

import { DialogBody, DialogContent, DialogHeader } from "@/shared/Dialog.jsx";
import { lazyComponent } from "@/util/lazy-component.mjs";

const AddCardDialogViewBody = lazyComponent(
  () => import("@/feature-wallet/AddCardDialogViewBody.jsx"),
);

export function AddCardDialogView({
  onAddedPaymentMethod,
  onBack,
}: {
  onAddedPaymentMethod(paymentMethodId: string): void;
  onBack(): void;
}) {
  return (
    <DialogContent>
      <DialogHeader
        title={["common:wallet.addPaymentMethod.card", "Add Credit Card"]}
        onPressBack={onBack}
      />

      <DialogBody>
        <AddCardDialogViewBody
          props={{ onAddedPaymentMethod }}
          fallback={<FlexibleLoadingSpinner />}
        />
      </DialogBody>
    </DialogContent>
  );
}
